import { LoginService } from 'services/LoginService'
import { UserService } from 'services/UserService'
import { ProgramService } from 'services/ProgramService'
import { ContentService } from 'services/ContentService'
import { ImageService } from 'services/ImageService'

class ServiceContainer
{
	public loginService: LoginService;
	public userService: UserService;
    public programService: ProgramService;
	public contentService: ContentService;
	public imageService: ImageService;

	constructor()
	{
		this.loginService = new LoginService();
		this.userService = new UserService(this.loginService);
        this.programService = new ProgramService(this.loginService);
		this.contentService = new ContentService(this.loginService);
		this.imageService = new ImageService(this.loginService);
	}
}

export const AppServices = new ServiceContainer();
export default AppServices;
